import { Avatar, Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { appApi } from '../../../../services/appApi'
import { formatarDataHora, tempoDecorrido } from '../../../../Utils/Helper'
import { TagStatus } from '../TagStatus'
import { ColumnRespostaRh, ColumnTitulo, Container, ContainerCollapse } from './styles'

interface Denuncia {
  id: string
  empresaId: string
  texto: string
  status: number
  dataCriacao: string
  dataAlterado?: string
  atualizacoes?: Atualizacao[]
}

interface Atualizacao {
  colaboradorId: string
  resposta: string
  avatar: string
  nome: string
  dataCriacao: string
  dataAlterado?: string
}

interface iBoxProps {
  denuncia: Denuncia
  reload: () => void
}

export const BoxMensagem: React.FC<iBoxProps> = ({ denuncia, reload }) => {
  const [Open, setOpen] = useState(false)
  const [Resposta, setResposta] = useState('')

  const Atualizacoes = denuncia.atualizacoes ?? []
  const UltimaAtualizacao = Atualizacoes[Atualizacoes.length - 1]

  function putResposta(): void {
    const form = {
      texto: Resposta
    }
    appApi.put(`api/ChamadosOuvidoria/${denuncia.id}`, form)
      .then(() => {
        reload()
        setResposta('')
      })
      .catch(err => console.log(err))
  }

  function EncerrarDenuncia(): void {
    appApi.patch(`api/ChamadosOuvidoria/${denuncia.id}/Encerrar`)
      .then(reload)
      .catch(err => console.log(err))
  }

  return (
    <Container active={Atualizacoes.length > 1}>

      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Flex maxW={'85%'}>
          <Avatar marginRight={'.5rem'} />
          <Flex flexDir={'column'}>
            <ColumnTitulo>
              <span>{formatarDataHora(denuncia.dataCriacao)} ({tempoDecorrido(denuncia.dataCriacao)})</span>
              <span>{denuncia.texto}</span>
            </ColumnTitulo>
            {
              denuncia.dataAlterado && (
                <Text fontSize={'.75rem'} color={'var(--Gray3)'} marginTop={'.25rem'}>
                  Última atualização em {formatarDataHora(denuncia.dataAlterado)}
                </Text>
              )
            }
          </Flex>
        </Flex>
        <Flex gap={'.5rem'} alignItems={'center'}>
          <TagStatus status={denuncia.status} />
          {denuncia.status === 0 && (
            <ButtonCmp onClick={EncerrarDenuncia} VarColor='Rosa'>Encerrar denúncia</ButtonCmp>
          )}
        </Flex>
      </Flex>
      <Flex flexDir='column' gap={'1rem'} mt={'.75rem'}>
        <small><strong>Ações:</strong> ({Atualizacoes.length > 0 ? Atualizacoes.length : 'Nenhuma'})</small>
        <ContainerCollapse active={Open}>
          {
            Atualizacoes.slice(0, -1).map((e, i) => (
              <Flex key={i}>
                <Avatar marginRight={'.5rem'} src={e.avatar} name={e.nome} />
                <ColumnRespostaRh>
                  <span><strong>{e.nome}</strong> · {formatarDataHora(e.dataCriacao)}</span>
                  <span>{e.resposta}</span>
                </ColumnRespostaRh>
              </Flex>
            ))
          }
        </ContainerCollapse>
        {
          UltimaAtualizacao && (
            <Flex>
              <Avatar marginRight={'.5rem'} src={UltimaAtualizacao.avatar} name={UltimaAtualizacao.nome} />
              <ColumnRespostaRh>
                <span><strong>{UltimaAtualizacao.nome}</strong> · {formatarDataHora(UltimaAtualizacao.dataCriacao)}</span>
                <span>{UltimaAtualizacao.resposta}</span>
              </ColumnRespostaRh>
            </Flex>
          )
        }

      </Flex>
      {
        (Atualizacoes.length > 1) && (
          <Flex onClick={() => setOpen(!Open)} color={'var(--Azul) !important'} justifyContent={'center'} mt={'.25rem'}>
            {
              !Open
                ? <>
                  <span>Visualizar todas as ações</span>
                  <FaAngleDown />
                </>
                : <>
                  <span>Recolher visualização</span>
                  <FaAngleUp />
                </>
            }
          </Flex>
        )
      }
        {denuncia.status === 0 && (
          <Flex gap={'.5rem'} alignItems={'end'}>
            <InputCmp label='Nova ação' value={Resposta} OnChange={(e) => setResposta(e)} placeholder='Digite sua resposta'/>
            <ButtonCmp VarColor='Green2' onClick={putResposta}>Salvar ação</ButtonCmp>
          </Flex>
        )}
    </Container>
  )
}
